import { ThemeStore } from './theme-store';
import { useState } from 'react';
import { useEnabledFeatures } from '~/common/hooks/enabled-features/use-enabled-features';
import { useApplicationType } from '~/common/hooks/use-application-type';

export const useGlobalThemeStore = () => {
    const applicationType = useApplicationType();
    const { allowLightModeEnabled, cadLightModeEnabled, firstResponderLightModeEnabled } =
        useEnabledFeatures();

    const [store] = useState(() => {
        const themeStore = new ThemeStore();

        // The default theme is dark. If light mode is allowed, then check if it is applied and set it.
        if (
            allowLightModeEnabled &&
            ((applicationType.isCad && cadLightModeEnabled) ||
                (applicationType.isFirstResponder && firstResponderLightModeEnabled))
        ) {
            themeStore.setTheme('light');
        }

        return themeStore;
    });

    return store;
};
